import { useEffect, useRef, useState } from 'react';
import { Input } from './styles';
import { Button, InputRef, Space, Tag, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useClip } from '../../contexts/clip/hook';
import { useToast } from '../../../../hooks/useToast';

export const EditableTitle = () => {
  const {
    isOwner,
    clip: { title },
  } = useClip();
  const [temporalTitle, setTemporalTitle] = useState(title || 'Default title');
  const { success, error } = useToast();
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    setTemporalTitle(title);
  }, [title]);

  const editTitleFeatureAvailable = isOwner;

  return (
    <Space
      style={{
        display: 'flex',
        alignContent: 'center',
        maxWidth: '600px',
        justifyContent: 'space-between',
      }}
    >
      <Space>
        <Tooltip title="Currently in Beta — share any and all feedback to concierge@update.ai">
          <Tag color="red">Beta</Tag>
        </Tooltip>
        <Input
          ref={inputRef}
          placeholder={title}
          value={temporalTitle}
          readOnly={true}
          bordered={false}
        />
      </Space>
      {/* for v1 we will not have title being edited */}
      {false && !isEditing && editTitleFeatureAvailable && (
        <Tooltip
          title={!editTitleFeatureAvailable ? "You don't have permission to edit this info" : null}
        >
          <Button
            disabled={!editTitleFeatureAvailable}
            icon={<EditOutlined />}
            shape="round"
            size="small"
            onClick={() => {
              setIsEditing(true);
              inputRef.current?.focus();
            }}
          />
        </Tooltip>
      )}
    </Space>
  );
};
